module.exports = __webpack_public_path__ + "img/94ne.f2e625f6.svg";